import Layout from '../../internal/Layout.vue'
import UploadDocumentPage from './uploadDocument.vue'

const UploadDocumentRoutes = {
  component: Layout,
  children: [
    {
      name: 'uploadDocument',
      path: '/',
      component: UploadDocumentPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
      },
    },
  ],
}

export default UploadDocumentRoutes
